module.exports = __webpack_public_path__ + "static/media/profile-bg.f57b6453.jpg";